/* Small progressive enhancements; all destinations and forms work without this file. */
(() => {
  'use strict';
  const controllers = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initBanner(slider) {
    if (controllers.has(slider)) return;
    const swiper = slider.globalSlide || slider.swiper;
    if (!swiper) return;
    const abort = new AbortController();
    const options = {signal: abort.signal};
    const toggle = slider.querySelector('[data-atelier-autoplay]');
    let pausedByUser = reducedMotion.matches;
    let inView = true;
    const requestedAutoplay = slider.dataset.autoplay === 'true';
    const syncAutoplay = () => {
      if (!requestedAutoplay || !swiper.autoplay || swiper.destroyed) return;
      const stop = pausedByUser || reducedMotion.matches || document.hidden || !inView || slider.matches(':focus-within') || slider.matches(':hover');
      if (stop) swiper.autoplay.stop();
      else swiper.autoplay.start();
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(pausedByUser));
        toggle.setAttribute('aria-label', pausedByUser ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        toggle.querySelector('[data-icon-pause]').hidden = pausedByUser;
        toggle.querySelector('[data-icon-play]').hidden = !pausedByUser;
      }
    };
    const syncSlides = () => {
      slider.querySelectorAll('.swiper-slide').forEach(slide => {
        const active = slide.classList.contains('swiper-slide-active');
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
    };
    toggle?.addEventListener('click', () => {pausedByUser = !pausedByUser;syncAutoplay();}, options);
    ['focusin','mouseenter'].forEach(name => slider.addEventListener(name, syncAutoplay, options));
    ['focusout','mouseleave'].forEach(name => slider.addEventListener(name, () => queueMicrotask(syncAutoplay), options));
    document.addEventListener('visibilitychange', syncAutoplay, options);
    reducedMotion.addEventListener('change', syncAutoplay, options);
    const observer = new IntersectionObserver(entries => {inView = entries[0].isIntersecting;syncAutoplay();});
    observer.observe(slider);
    swiper.on('slideChange', syncSlides);
    swiper.on('autoplayStart', () => {
      if (pausedByUser || reducedMotion.matches || document.hidden || !inView) swiper.autoplay.stop();
    });
    slider.addEventListener('shopify:block:select', event => {
      const slide = event.target.closest('.swiper-slide');
      const index = Array.from(slider.querySelectorAll('.swiper-slide')).indexOf(slide);
      if (index < 0) return;
      pausedByUser = true;
      if (swiper.params.loop && swiper.slideToLoop) swiper.slideToLoop(index, 0);
      else swiper.slideTo(index, 0);
      syncSlides();syncAutoplay();
    }, options);
    syncSlides();syncAutoplay();
    controllers.set(slider, () => {abort.abort();observer.disconnect();swiper.off('slideChange', syncSlides);});
  }

  function initialize(scope = document) {
    scope.querySelectorAll('slide-section.slideshow').forEach(initBanner);
    const nav = document.querySelector('mobile-navigation-bar');
    document.body.classList.toggle('atelier-has-mobile-nav', Boolean(nav));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => requestAnimationFrame(() => initialize(event.target)));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('slide-section.slideshow').forEach(slider => {
      controllers.get(slider)?.();controllers.delete(slider);
    });
  });
})();
